import { render, staticRenderFns } from "./v-catalog.vue?vue&type=template&id=a671760c&"
import script from "./v-catalog.vue?vue&type=script&lang=js&"
export * from "./v-catalog.vue?vue&type=script&lang=js&"
import style0 from "./v-catalog.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports